import { useMemo } from 'react';
import { FlexSpacer } from 'ui/flexSpacer';
import { useMissionControlContext } from 'modules/missionControl/contexts/MissionControlContext';
import { useMetricsContext } from 'modules/productAnalytics/context';
import { CampaignsHealthMetricsSkeleton } from './CampaignsHealthMetricsSkeleton';
import {
  CampaignsHealthMetricsZeroState,
  CampaignsHealthMetricsErrorState,
} from './CampaignsHealthMetricsStates';
import { useDevPanelContext } from '../../DevPanel/context/DevPanelContext';
import { MetricsCharts } from './charts/MetricsCharts';
import { MetricsTable } from './table/MetricsTable';

export const CampaignsHealthMetricsContents = () => {
  const {
    campaignsHealthMetricsQuery: {
      metrics,
      isLoading: isLoadingSendMetrics,
      hasError: hasSendMetricsError,
      refetch,
    },
  } = useMissionControlContext();
  const { metricsLoading: isLoadingMetricsData } = useMetricsContext();

  const overallMetricsData = Object.values(metrics?.totalMetricsAggregations ?? {});
  const hasSendMetricsOverallData = overallMetricsData.length > 0;

  const hasNoSendData = useMemo(
    () => hasSendMetricsOverallData && overallMetricsData.every((metric) => !metric.value),
    [overallMetricsData, hasSendMetricsOverallData],
  );

  const {
    devToolSendsStates: {
      isDevToolLoadingStateEnabled,
      isDevToolErrorStateEnabled,
      isDevToolDataStateEnabled,
      isDevToolZeroStateEnabled,
    },
  } = useDevPanelContext();

  const isLoadingState =
    isDevToolLoadingStateEnabled || isLoadingSendMetrics || isLoadingMetricsData;
  const isErrorState = isDevToolErrorStateEnabled || hasSendMetricsError;
  const isZeroState = isDevToolZeroStateEnabled || hasNoSendData;
  const isDataState = isDevToolDataStateEnabled || !hasNoSendData;

  switch (true) {
    case isLoadingState:
      return <CampaignsHealthMetricsSkeleton />;

    case isErrorState:
      return (
        <FlexSpacer justifyContent="center" alignItems="center" width="100%">
          <CampaignsHealthMetricsErrorState refetch={refetch} />
        </FlexSpacer>
      );

    case isZeroState:
      return (
        <FlexSpacer justifyContent="center" alignItems="center" width="100%">
          <CampaignsHealthMetricsZeroState />
        </FlexSpacer>
      );

    case isDataState:
      return (
        <>
          <MetricsCharts />
          <MetricsTable />
        </>
      );

    default:
      return (
        <FlexSpacer justifyContent="center" alignItems="center" width="100%">
          <CampaignsHealthMetricsErrorState refetch={refetch} />
        </FlexSpacer>
      );
  }
};
